import { ref } from 'vue';
import { defineStore } from 'pinia';
import dayjs from 'dayjs';
import { companyApi,NVRConfigApi } from '@/view-modules/config-manage/api';
import { PackageStatus,LoginModel } from '@/global-utils/enum';

export const useSysStore =  defineStore(
	'sys',
	() => {
		const sysName: any = ref('');
        const sysLogo: any = ref('');
        const sysIco: any = ref('');
		const companyName: any = ref('');
		const isNewUser: any = ref(0);

		const nvrStatus = ref<null | number>(null);
		const nvrInfo: any = ref<{ip:string,port:number,username:string,password:string} | {}>({});

		// 套餐类型举
		const packageType = ref<number>(-1);//
		// 套餐状态举
		const packageStatus = ref<number>(PackageStatus.NOT_ACTIVIVATED);
		// 套餐过期时间
		const packageExpireTime = ref<string>('');

		// 登录模式 普通用户登录和商户管理平台跳转登录
		const loginModel = ref<LoginModel>(LoginModel.TENANT);

		const setSysName: any = (value: string) => {
			sysName.value = value;
		};

        const setSysLogo: any = (value: string) => {
			sysLogo.value = value;
		};

        const setCompanyName: any = (value: string) => {
			companyName.value = value;
		};

        const setSysIco: any = (value: string) => {
			sysIco.value = value;
		};

        const getSysInfo: any = async () => {
			const res=await companyApi.getCompanyInfo();

			if (res.code !== 0) return;

			const companyName = res.data?.companyName || 'SPC安全生产管理平台';
			const sysName = res.data?.sysName || 'SPC安全生产管理平台';
			const sysLogo = res.data?.sysLogo || '/logo.png';
			const sysIco = res.data?.sysIcon || '/favicon.ico';
	
			document.querySelector('#sys-title')!.innerHTML = sysName;
			document.querySelector('#sys-favicon')!.setAttribute('href', sysIco);
			setSysLogo(sysLogo);
			setSysName(sysName);
			setSysIco(sysIco);
			setCompanyName(companyName);
			
		};

		const getNvrStatus: any = async () => {
			try {
				
				const info=await NVRConfigApi.getNvrInfo();
				
				if (info.code !== 0 || info.data === null) return;

				nvrInfo.value = {...info.data};

				const res=await NVRConfigApi.getNvrStatus(info.data);
				if (res.code === 0) {
					let sysStatus = 0;
					switch (res.data) {
						case 200 ://正常
							sysStatus = 1;
							break;
						default://失败
							sysStatus=0;
							break;
					}
					nvrStatus.value = sysStatus;
				}else{
					console.error(res.message);
					nvrStatus.value = 0;//失败
				}
			} catch (error) {
				console.error(error);
				nvrStatus.value = 0;//失败
			}
		};

		// 设置套餐类型
		const setPackageType: any = (value: number) => {
			packageType.value = value;
		};
		// 设置套餐状态
		const setPackageStatus: any = (value: number) => {
			packageStatus.value = value;
		};

		// 设置套餐过期时间
		const setPackageExpireTime: any = (value: string | null) => {
			if (!value) {
				packageExpireTime.value = '';
				return
			};
			packageExpireTime.value = dayjs(value).format('YYYY-MM-DD');
		};

		const setLoginModel: any = (value: LoginModel) => {
			loginModel.value = value;
		};

		// 设置是否是新用户
		const setIsNewUser: any = (value: number) => {
			isNewUser.value = value;
		};
		
		
		return {
			sysName,
			setSysName,
            setSysLogo,
			companyName,
			nvrStatus,
			nvrInfo,
			sysIco,
            sysLogo,
            getSysInfo,
            setSysIco,
            setCompanyName,
			getNvrStatus,
			packageType,
			packageStatus,
			packageExpireTime,
			loginModel,
			isNewUser,
			setPackageType,
			setPackageStatus,
			setPackageExpireTime,
			setLoginModel,
			setIsNewUser,

		};
	},
	{
		persist: [
			{
				pick: ['sysName'],
				key: 'sysName'
			},
			{
				pick: ['companyName'],
				key: 'companyName'
			},
            {
                pick: ['sysLogo'],
                key: 'sysLogo'
            },
            {
                pick: ['sysIco'],
                key: 'sysIco'
            },
            {
                pick: ['packageType'],
                key: 'packageType'
            },
			{
				pick: ['packageStatus'],
				key: 'packageStatus'
			},
			{
				pick: ['packageExpireTime'],
				key: 'packageExpireTime'
			},
			{
				pick: ['loginModel'],
				key: 'loginModel'
			},
			{
				pick: ['isNewUser'],
				key: 'isNewUser'
			},
		]
	}
);